// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"201":"f788c592","577":"24fd6639","657":"9e8f7c9d","849":"174b42cc"}[chunkId] + ".chunk.css";
};